import IRestServiceFilter from "./IRestServiceFilter";
import IRestServiceFilterNested from "./IRestServiceFilterNested";

type FiltersType<T> = {
    [index in (number | string)]: T
}

export const isFilterNested = (filter: IRestServiceFilter | IRestServiceFilterNested): filter is IRestServiceFilterNested => {
    return 'children' in filter;
}

export const getBaseFieldsList = (data: IRestServiceFilters): string[] => {
    let list: string[] = []
    Object.entries(data).forEach(([_, filter]) => {
            if (!isFilterNested(filter)) {
                list.push(filter.field.split('.')[0])
            } else {
                list = [...list, ...getBaseFieldsList(filter.children)]
            }
        }
    )
    return list
}

export default interface IRestServiceFilters<T = IRestServiceFilter | IRestServiceFilterNested> extends FiltersType<T> {

}